import { render, staticRenderFns } from "./PastStories.vue?vue&type=template&id=2170eeae&scoped=true&"
import script from "./PastStories.vue?vue&type=script&lang=js&"
export * from "./PastStories.vue?vue&type=script&lang=js&"
import style0 from "./PastStories.vue?vue&type=style&index=0&id=2170eeae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2170eeae",
  null
  
)

export default component.exports